import React, { Component } from 'react';
import PropTypes from 'prop-types';
import reactCSS from 'reactcss';
import { TwitterPicker } from 'react-color';

class ColorPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayColorPicker: false,
      color: props.value,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ color: nextProps.value });
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = (color) => {
    this.setState({ color: color.hex }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.color);
      }
    });
  };

  render() {
    const { className } = this.props;
    const { color, displayColorPicker } = this.state;

    const styles = reactCSS({
      default: {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: color,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '200',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
        square: {
          width: '30px',
          height: '30px',
          borderRadius: '5px',
          background: color,
          border: '1px solid',
        },
      },
    });

    return (
      <div className={className}>
        <div onClick={this.handleClick}>
          <div style={styles.square} />
        </div>
        {displayColorPicker ? (
          <div style={styles.popover}>
            <div style={styles.cover} onClick={this.handleClose} />
            <TwitterPicker color={color} onChange={this.handleChange} />
          </div>
        ) : null}
      </div>
    );
  }
}

ColorPicker.propTypes = {
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ColorPicker.defaultProps = {
  className: 'form-control',
};

export default ColorPicker;
